<template>
    <div class="space-y-6">

        <draggable :list="estimate.cover_letter_items" draggable=".draggable" handle=".handle" @change="fieldsReordered" :disabled="estimate.cannot_be_edited_by_authed_user" class="space-y-6">
            <div v-for="(field, index) in estimate.cover_letter_items" :key="index" class="draggable">
                <div class="flex items-start mb-1">
                    <div class="w-6 flex-shrink-0 py-1.5" v-if="! estimate.cannot_be_edited_by_authed_user">
                        <i class="fa fa-bars text-sm text-gray-300 hover:text-gray-500 cursor-move handle"></i>
                    </div>
                    <input
                        placeholder="Untitled field"
                        class="flex-1 text-sm m-0 px-2 py-1 font-medium text-gray-700 border-transparent rounded shadow-none relative focus:z-10"
                        type="text"
                        ref="titles"
                        v-model="field.title"
                        @input="estimate.cannot_be_edited_by_authed_user ? null : $store.save()"
                        :disabled="estimate.cannot_be_edited_by_authed_user"
                    >
                    <div class="w-6 flex-shrink-0 ml-2 self-start py-1.5" v-if="! estimate.cannot_be_edited_by_authed_user">
                        <ui-dropdown menu-class="p-3 w-48">
                            <template #default="{ toggle }">
                                <button @click="toggle" class="w-5 h-5 flex items-center justify-center text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative rounded">
                                    <i class="fa fa-ellipsis-h fa-fw"></i>
                                </button>
                            </template>
                            <template #menu="{ close }">
                                <ui-dropdown-item icon="fas fa-trash" danger @click="deleteField(index); close()">Delete</ui-dropdown-item>
                            </template>
                        </ui-dropdown>
                    </div>
                </div>
                <ui-textarea
                    autoresize
                    rows="1"
                    field="resize-none"
                    name="content"
                    v-model="field.content"
                    @input="estimate.cannot_be_edited_by_authed_user ? null : $store.save()"
                    :disabled="estimate.cannot_be_edited_by_authed_user"
                ></ui-textarea>
            </div>
        </draggable>

        <!-- New Item. -->
        <div class="relative" v-if="! estimate.cannot_be_edited_by_authed_user">
            <input
                placeholder="Add New Paragraph..."
                class="text-sm m-0 pl-8 pr-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative"
                type="text"
                v-model="newFieldTitle"
                @input="addField"
            >
            <div class="absolute left-0 inset-y-0 w-8 flex items-center justify-center">
                <i class="fa fa-plus text-sm text-gray-400"></i>
            </div>
        </div>
    </div>
</template>

<script>
import { estimateStore } from '@stores'
import draggable from 'vuedraggable'

export default {
    components: {
        draggable,
    },
    data () {
        return {
            newFieldTitle: '',
        }
    },
    computed: {
        $store () {
            return estimateStore
        },
        estimate () {
            return estimateStore.state.estimate
        },
    },
    methods: {
        addField () {
            this.estimate.cover_letter_items.push({
                title: this.newFieldTitle,
                content: '',
            })
            this.$store.save()

            this.$nextTick(() => {
                const input = this.$refs.titles[this.$refs.titles.length - 1]
                input.focus()
                this.newFieldTitle = ''
            })
        },
        deleteField (index) {
            this.estimate.cover_letter_items.splice(index, 1)
            this.$store.save()
        },
        fieldsReordered () {
            this.$store.save()
        },
    },
}
</script>
